/// <amd-module name="VSSUI/Components/Page/Page" />
import * as React from "react";

import { IPageProps, Orientation } from "./Page.Props";

import { ObservableArray } from "VSS/Core/Observable";

import { Intersection } from "VSSUI/Intersection";
import { SurfaceBackground, SurfaceContext } from "VSSUI/Surface";
import { TabGroupProvider, TabProvider } from "VSSUI/Tabs";
import { css } from "VSSUI/Util";

/**
 * Component for stitching together the various components that make a up a page.
 * Renders all children in a column-based flexbox.
 * If passed an observable selected tab id and contributed tab providers, will
 * wrap with a TabProvider component to provide context to consuming children.
 */
export class Page extends React.Component<IPageProps> {
    public render(): JSX.Element {
        const { tabProviders, selectedTabId, tabGroups, orientation = Orientation.Vertical, scrollableContainerRef, onScroll } = this.props;
        const orientationClass = orientation === Orientation.Vertical ? "flex-column" : "flex-row";

        let page = (
            <SurfaceContext.Consumer>
                {surfaceContext => (
                    <Intersection>
                        <div
                            ref={scrollableContainerRef}
                            onScroll={onScroll}
                            className={css(
                                this.props.className,
                                "bolt-page v-scroll-auto",
                                orientationClass,
                                surfaceContext.background === SurfaceBackground.neutral && "bolt-page-grey",
                                surfaceContext.background === SurfaceBackground.normal && "bolt-page-white"
                            )}
                        >
                            {this.props.children}
                        </div>
                    </Intersection>
                )}
            </SurfaceContext.Consumer>
        );

        if (selectedTabId) {
            page = (
                <TabProvider providers={tabProviders || new ObservableArray([])} selectedTabId={selectedTabId}>
                    {page}
                </TabProvider>
            );
        }

        if (tabGroups) {
            page = <TabGroupProvider providers={tabGroups}>{page}</TabGroupProvider>;
        }

        return page;
    }
}
